import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import Header from "../components/Common/Header";
import PanVerification from "../components/repay-loan/PanVerification";
import OtpVerification from "../components/repay-loan/OtpVerification";
import LoanDetails from "../components/repay-loan/LoanDetails";
import PaymentSuccess from "../components/repay-loan/PaymentSuccess";
import BankDetails from "../components/repay-loan/BankDetails";
import InformationSection from "../components/repay-loan/InformationSection";
import PAYMENT_QR from "../images/kubersetuqr.png";
import SecurityAlertModal from "../components/repay-loan/SecurityAlertModal";
import VN_CREDITS_QR from "../images/vn_qr.jpeg";
import { motion } from "framer-motion";
import { NBFC, getNbfcPaymentDetails } from "../config/nbfcPaymentConfig";
// import PaymentModal from "../components/common/PaymentModal";
// import usePayment from "../hooks/usePayment";
import {
  sendOtp,
  verifyOtp,
  getRepaymentDetailsByPan,
} from "../components/Common/PaymentService";

export default function RepayLoan() {
  const navigate = useNavigate();
  const [showSecurityAlert, setShowSecurityAlert] = useState(true);
  const [content, setContent] = useState("pannumber");
  const [pancard, setPancard] = useState("");
  const [repaymentData, setRepaymentData] = useState(null);
  const [orderId, setOrderId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [loanNbfc, setLoanNbfc] = useState(null);

  const nbfcDetails = getNbfcPaymentDetails(loanNbfc);
  const qrCodeSrc = loanNbfc === NBFC.VN_CREDITS ? VN_CREDITS_QR : PAYMENT_QR;

  const { loading, setLoading, initiateRazorpayPayment, initiatePayUPayment } =
    {};
  //   usePayment();

  const showMessage = (message) => {
    toast.success(message);
  };

  const handleFetchData = async (pancardValue) => {
    setPancard(pancardValue);
    // setLoading(true);
    try {
      const dataset = await getRepaymentDetailsByPan(pancardValue);
      console.log("dataset", dataset);
      showMessage(dataset.message);
      if (dataset.status == 1) {
        setContent("panotp");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    } finally {
      // setLoading(false);
    }
  };

  const handleVerifyOtp = async (otpValue) => {
    setLoading(true);
    try {
      const dataset = await verifyOtp(pancard, otpValue);
      showMessage(dataset.Message);

      if (dataset.Status === 1) {
        const repayData = dataset.repayment_data;
        setRepaymentData(repayData);
        setOrderId(dataset.order_id);
        setContent("amountfetched");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoanFetched = (data) => {
    setLoanNbfc(data?.nbfc || null);
  };

  const handlePaymentClick = (amount) => {
    setPaymentAmount(amount);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleRazorpay = () => {
    setModalOpen(false);
    initiateRazorpayPayment(repaymentData, orderId, paymentAmount);
  };

  const handlePayU = () => {
    setModalOpen(false);
    initiatePayUPayment(repaymentData, paymentAmount);
  };

  return (
    <>
      <Header title="Funds Repayment" />
      <SecurityAlertModal
        isOpen={showSecurityAlert}
        onProceed={() => setShowSecurityAlert(false)}
        onCancel={() => navigate("/")}
      />
      <div className="w-full min-h-screen flex flex-col items-center bg-[#0A1620] text-white border border-[#2D5F7A]/30 shadow-md relative overflow-hidden">
        {/* Static Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-20 left-[5%] w-72 h-72 bg-[#2D5F7A]/10 rounded-full blur-3xl" />
          <div className="absolute bottom-20 right-[5%] w-96 h-96 bg-[#7BC4E0]/10 rounded-full blur-3xl" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#1E3B4A]/20 rounded-full blur-3xl" />
        </div>

        {/* Static Bubbles */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="absolute rounded-full bg-[#7BC4E0]"
              style={{
                width: Math.random() * 15 + 8,
                height: Math.random() * 15 + 8,
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                opacity: Math.random() * 0.1 + 0.03,
              }}
            />
          ))}
        </div>

        <div className="w-full max-w-6xl px-0 sm:px-2 md:px-8 mx-auto relative z-10">
          <div className="bg-[#1A2F3A] rounded-lg shadow-md p-2 sm:p-2 md:p-8 mb-6 sm:mb-8 relative overflow-hidden border border-[#2D5F7A]/30">
            {/* Inner Static Elements for Card */}
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute -top-10 -right-10 w-40 h-40  rounded-full blur-3xl" />
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#7BC4E0]/10 rounded-full blur-3xl" />
            </div>

            {/* Blue Line Above Content */}
            <div className="flex flex-wrap items-center justify-between gap-3 mb-6 relative z-10">
              <div className="flex items-center gap-3">
                <div className="w-[60px] h-1 bg-[#7BC4E0] rounded-full" />
                <span className="text-xs font-medium text-[#7BC4E0] tracking-wider">
                  FUNDS REPAYMENT
                </span>
              </div>
              <button
                type="button"
                onClick={() => setShowSecurityAlert(true)}
                className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 hover:bg-red-500/20 text-red-300 border border-red-500/30 text-xs font-medium transition-colors cursor-pointer"
                title="Click to view security & fraud alert"
              >
                <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse" />
                Security Alert / सुरक्षा चेतावनी देखें
              </button>
            </div>

            {content === "pannumber" ? (
              <PanVerification
                // onOtpReceived={handleSendOtp}
                fetchData={handleFetchData}
                onLoanFetched={handleLoanFetched}
                loading={loading}
              />
            ) : content === "panotp" ? (
              <OtpVerification
                pancard={pancard}
                onOtpVerified={handleVerifyOtp}
                loading={loading}
              />
            ) : content === "amountfetched" && repaymentData ? (
              <LoanDetails
                repaymentData={repaymentData}
                onPaymentClick={handlePaymentClick}
                loading={loading}
              />
            ) : content === "paymentSuccess" ? (
              <PaymentSuccess status={paymentStatus} />
            ) : null}
          </div>

          {loanNbfc && (
            <BankDetails
              bankName={nbfcDetails.bankName}
              companyName={nbfcDetails.companyName}
              accountNo={nbfcDetails.accountNo}
              ifscCode={nbfcDetails.ifscCode}
              branchAddress={nbfcDetails.branchAddress}
              accountType={nbfcDetails.accountType}
              qrCodeSrc={qrCodeSrc}
              upiId={nbfcDetails.upiId}
              swiftCode={nbfcDetails.swiftCode}
            />
          )}
          {/* <BankDetails
      bankName="Bank of Baroda"
      companyName="VN Credits Pvt Ltd"
      accountNo="45230200001507"
      ifscCode="BARBOMALVIY"
      branchAddress="SELECT CITYWALK. SAKET BRANCH, DELHI 110017"
      accountType="Current"
      qrCodeSrc={NamanQR}
      upiId="naman99539@barodampay"
    /> */}
          {/* <BankDetails
      bankName="HDFC Bank Ltd"
      companyName="VN Credits Pvt Ltd"
      accountNo="59208588888450"
      ifscCode="HDFC0000248"
      branchAddress="S-355 Panchshila Park New Delhi 110017"
      accountType="Current"
      qrCodeSrc={BOBQR}
      upiId="vyapar.174180804884@hdfcbank"
    /> */}

          <InformationSection />
        </div>

        {/* {isModalOpen && (
    <PaymentModal
      onClose={handleCloseModal}
      onRazorpay={handleRazorpay}
      onPayU={handlePayU}
      isLoading={loading}
    />
  )} */}
      </div>

      <style jsx>{`
        @keyframes pulse {
          0%,
          100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.05);
          }
        }
        .animate-pulse {
          animation: pulse 2s ease-in-out infinite;
        }
      `}</style>
    </>
  );
}
